// extracted by mini-css-extract-plugin
export default {"container":"Sidebar_container__uCTqn","content":"Sidebar_content__A17Iv"};